//#region ../schema-sql-parser/dist/parser/dataType/MySQL.js
var MySQLTypes = [
	"BIGINT",
	"BINARY",
	"BIT",
	"BLOB",
	"BOOL",
	"BOOLEAN",
	"CHAR BYTE",
	"CHAR",
	"CHARACTER VARYING",
	"CHARACTER",
	"DATE",
	"DATETIME",
	"DEC",
	"DECIMAL",
	"DOUBLE PRECISION",
	"DOUBLE",
	"ENUM",
	"FIXED",
	"FLOAT",
	"FLOAT4",
	"FLOAT8",
	"GEOMCOLLECTION",
	"GEOMETRY",
	"GEOMETRYCOLLECTION",
	"INT",
	"INT1",
	"INT2",
	"INT3",
	"INT4",
	"INT8",
	"INTEGER",
	"JSON",
	"LINESTRING",
	"LONG VARBINARY",
	"LONG VARCHAR",
	"LONG",
	"LONGBLOB",
	"LONGTEXT",
	"MEDIUMBLOB",
	"MEDIUMINT",
	"MEDIUMTEXT",
	"MIDDLEINT",
	"MULTILINESTRING",
	"MULTIPOINT",
	"MULTIPOLYGON",
	"NATIONAL CHAR VARYING",
	"NATIONAL CHAR",
	"NATIONAL CHARACTER VARYING",
	"NATIONAL CHARACTER",
	"NATIONAL VARCHAR",
	"NCHAR VARCHAR",
	"NCHAR",
	"NUMERIC",
	"NVARCHAR",
	"POINT",
	"POLYGON",
	"REAL",
	"SERIAL",
	"SET",
	"SMALLINT",
	"TEXT",
	"TIME",
	"TIMESTAMP",
	"TINYBLOB",
	"TINYINT",
	"TINYTEXT",
	"VARBINARY",
	"VARCHAR",
	"VARCHARACTER",
	"YEAR"
];
//#endregion
export { MySQLTypes };
